import { ChevronDown } from 'lucide-react';

interface BankBalanceFiltersProps {
    year: number;
    month: number;
    companyCode: string | null;
    resolvedCompany: string | null;
    onYearChange: (year: number) => void;
    onMonthChange: (month: number) => void;
    onCompanyChange: (company: string | null) => void;
    isAdmin?: boolean;
}

const YEARS = Array.from({ length: 7 }, (_, i) => 2022 + i);
const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];
const COMPANIES = ['bin', 'dbi', 'dch', 'dfr', 'dit', 'dpt', 'dsp', 'dtr'];

export function BankBalanceFilters({
    year, month, companyCode, resolvedCompany,
    onYearChange, onMonthChange, onCompanyChange,
    isAdmin,
}: BankBalanceFiltersProps) {
    return (
        <div className="flex items-center gap-3 flex-wrap">
            {/* Year */}
            <div className="relative">
                <select
                    value={year}
                    onChange={e => onYearChange(Number(e.target.value))}
                    className="appearance-none bg-white border border-gray-300 rounded-lg px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    {YEARS.map(y => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
                <ChevronDown className="absolute right-2 top-2.5 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>

            {/* Month */}
            <div className="relative">
                <select
                    value={month}
                    onChange={e => onMonthChange(Number(e.target.value))}
                    className="appearance-none bg-white border border-gray-300 rounded-lg px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    {MONTHS.map((m, i) => (
                        <option key={i + 1} value={i + 1}>{m}</option>
                    ))}
                </select>
                <ChevronDown className="absolute right-2 top-2.5 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>

            {/* Company (admin only) */}
            {isAdmin && (
                <div className="relative">
                    <select
                        value={companyCode || resolvedCompany || ''}
                        onChange={e => onCompanyChange(e.target.value || null)}
                        className="appearance-none bg-white border border-gray-300 rounded-lg px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {COMPANIES.map(c => (
                            <option key={c} value={c}>{c.toUpperCase()}</option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-2 top-2.5 w-4 h-4 text-gray-400 pointer-events-none" />
                </div>
            )}

            {/* Show resolved company for non-admins */}
            {!isAdmin && resolvedCompany && (
                <span className="text-sm text-gray-500 bg-gray-100 px-3 py-2 rounded-lg">
                    {resolvedCompany.toUpperCase()}
                </span>
            )}
        </div>
    );
}
